{
    "locale": "es-ES",
    "General": {
        "OrText": "O",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Ir a My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Crear cuenta",
        "ButtonText_SignInToYourAccount": "Iniciar sesión",
        "ButtonText_StartInterviewWithoutSigningUp": "Empezar la entrevista sin crear cuenta",
        "ButtonText_StartInterviewWithoutSigningIn": "Empezar la entrevista sin iniciar sesión",
        "Navlink_Dashboard": "Panel",
        "Navlink_MyInterviews": "Mis entrevistas",
        "Navlink_LearnWithHubert": "Aprende con Hubert",
        "Navlink_HelpCenter": "Centro de ayuda",
        "MyProfile": "Mi perfil",
        "LogOut": "Cerrar sesión"
    },
    "Login": {
        "MainTitle": "Ver los resultados de tu entrevista con Hubert",
        "Subtitle": "Inicia sesión para ver resultados, recibir feedback, leer consejos y mucho más.",
        "LoginTitle": "Inicia sesión en tu cuenta de Hubert",
        "Label_Email": "Correo electrónico",
        "Label_Password": "Contraseña",
        "ButtonText_SignIn": "Iniciar sesión",
        "ButtonText_ForgotPassword": "¿Has olvidado tu contraseña?",
        "ButtonText_ContinueWithGoogle": "Continuar con Google",
        "OrSeparator": "O",
        "Error_Email_Required": "El correo electrónico es obligatorio.",
        "Error_Email_Invalid": "Introduce un correo electrónico válido.",
        "Error_Password_Required": "La contraseña es obligatoria.",
        "Error_Use_Same_Email_As_Interview": "Usa el mismo correo electrónico que indicaste en la entrevista."
    },
    "Registration": {
        "MainTitle": "Ver los resultados de tu entrevista con Hubert",
        "Subtitle": "Crea tu cuenta para ver resultados, recibir feedback, leer consejos y mucho más.",
        "RegistrationTitle": "Crear cuenta de Hubert",
        "BenefitsBox_Title": "Con tu cuenta podrás",
        "BenefitsBox_Point1": "Ver tu historial de entrevistas",
        "BenefitsBox_Point2": "Recibir feedback sobre tus entrevistas",
        "BenefitsBox_Point3": "Reutilizar respuestas en nuevas entrevistas",
        "BenefitsBox_Point4": "Recibir consejos para entrevistas",
        "BenefitsBox_Point5": "Leer guías de carrera",
        "BenefitsBox_Point6": "Y mucho más",
        "Label_FirstName": "Nombre",
        "Label_LastName": "Apellidos",
        "Label_Email": "Correo electrónico",
        "Label_Password": "Contraseña",
        "Label_PhoneNumber": "Número de teléfono",
        "Label_TermsOfService": "Acepto la",
        "Label_TermsOfServiceLink": "Política de privacidad y los Términos y Condiciones",
        "Placeholder_CountryCode": "Selecciona el prefijo",
        "Placeholder_PhoneNumber": "P. ej., 600000000",
        "HelpText_Password": "La contraseña debe tener al menos 6 caracteres.",
        "ButtonText_SignUp": "Crear cuenta",
        "ButtonText_SignUpWithGoogle": "Crear cuenta con Google",
        "OrSeparator": "O",
        "Error_FirstName_Required": "El nombre es obligatorio.",
        "Error_LastName_Required": "Los apellidos son obligatorios.",
        "Error_Email_Required": "El correo electrónico es obligatorio.",
        "Error_Email_Invalid": "Introduce un correo electrónico válido.",
        "Error_Email_Exists": "Este correo electrónico ya está en uso.",
        "Error_Password_Required": "La contraseña es obligatoria.",
        "Error_Password_6_Characters": "La contraseña debe tener al menos 6 caracteres.",
        "Error_PhoneNumber_Required": "El número de teléfono es obligatorio.",
        "Error_PhoneNumber_Invalid": "El número de teléfono no es válido.",
        "Error_PrivacyPolicyCheck_Required": "Debes aceptar la Política de privacidad y los Términos y Condiciones."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Para hacer la entrevista, acepta los términos y condiciones de uso de Hubert. Marca la casilla para continuar.",
        "Subtitle_AfterInterviewCompleted": "Crea tu cuenta para ver resultados, recibir feedback, leer consejos y mucho más.",
        "PrivacyPolicyText": "Al crear la cuenta, aceptas la",
        "PrivacyPolicyLink": " Política de privacidad y los Términos y Condiciones",
        "ButtonText_SignUp": "Crear cuenta e ir a la entrevista",
        "ButtonText_SignUpNormal": "Crear cuenta",
        "ButtonText_SignInInstead": "Haz clic aquí para iniciar sesión"
    },
    "LoginInviteEmail": {
        "Subtitle": "Inicia sesión para ver resultados, recibir feedback, leer consejos y mucho más."
    },
    "AppMessages": {
        "internal-server-error": "Se ha producido un error inesperado.",
        "invalid-credentials": "Credenciales no válidas. Inténtalo de nuevo.",
        "user-not-found": "Credenciales no válidas. Inténtalo de nuevo.",
        "account-not-found": "Cuenta no válida. Inténtalo de nuevo.",
        "verify-email-title": "Verifica tu correo electrónico",
        "verify-email-subtitle": "Revisa tu correo para verificar tu cuenta.",
        "email-not-verified-title": "Correo electrónico no verificado",
        "email-not-verified-subtitle": "Revisa tu correo para verificar tu cuenta.",
        "verifying-email-title": "Verificando correo electrónico",
        "verifying-email-subtitle": "Espera un momento…",
        "sign-in-title": "Iniciando sesión",
        "sign-in-subtitle": "Espera un momento…",
        "server-error": "Algo ha ido mal.",
        "hubert-user-exists": "La cuenta ya existe.",
        "account-exists": "La cuenta ya existe.",
        "email-verified": "Tu correo electrónico se ha verificado.",
        "email-is-taken": "Este correo electrónico ya está en uso.",
        "re-enter-password": "Usa tu contraseña para iniciar sesión",
        "password-reset": "Tu contraseña se ha cambiado.",
        "re-enter-new-password": "Usa tu nueva contraseña para iniciar sesión",
        "invalid-invitation": "Invitación no válida.",
        "invalid-code": "Código de verificación no válido.",
        "email-already-verified": "El correo electrónico ya está verificado.",
        "email-mismatch-title": "El correo electrónico no coincide",
        "email-mismatch-subtitle": "Usa el mismo correo electrónico con el que solicitaste el puesto."
    },
    "TransitionPage": {
        "loading-title": "Cargando…",
        "loading-subtitle": "Preparando tus datos…",
        "logout-title": "Cargando…",
        "logout-subtitle": "Cerrando sesión…"
    },
    "ImpersonationPage": {
        "loading-title": "Cargando…",
        "loading-subtitle": "Preparando tus datos…"
    },
    "ProcessInvitation": {
        "loading-title": "Cargando…",
        "loading-subtitle": "Espera mientras cargamos tu entrevista.",
        "InvitationNotFound": "No encontramos tu entrevista.",
        "InvitationExpired": "Este enlace para acceder a la entrevista ha caducado.",
        "InvitationExpired_Description1": "Abre la entrevista desde",
        "InvitationExpired_Description2": "o contacta con el equipo de selección.",
        "InvitationInvalid": "El enlace de esta invitación no es válido.",
        "InterviewCompleted": "Esta entrevista ya se ha completado."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mis entrevistas",
            "TableHead_Employer": "Empresa",
            "TableHead_Job": "Puesto",
            "TableHead_Status": "Estado",
            "TableHead_ApplicationDate": "Fecha de solicitud",
            "TableBody_StartInterview": "La entrevista no está completada. Haz clic aquí para empezarla o retomarla.",
            "TableBody_NotScored": "La entrevista está completada. Los resultados estarán disponibles en breve.",
            "TableBody_Details": "Haz clic aquí para ver los resultados de la entrevista y más.",
            "ApplicationDate_Invited": "Invitado",
            "ApplicationDate_MinuteAgo": "minuto atrás",
            "ApplicationDate_MinutesAgo": "minutos atrás",
            "ApplicationDate_HourAgo": "hora atrás",
            "ApplicationDate_HoursAgo": "horas atrás",
            "ApplicationDate_DayAgo": "día atrás",
            "ApplicationDate_DaysAgo": "días atrás",
            "ButtonText_SeeAllInterviews": "Ver todas las entrevistas",
            "ButtonText_Details": "Detalles",
            "ButtonText_StartInterview": "Ir a la entrevista",
            "ButtonText_NotScored": "Resultados pendientes",
            "NoInterviews_Message": "No hay registros de entrevistas anteriores o próximas para ti."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Ahora mismo no hay ofertas disponibles. Vuelve a intentarlo más tarde."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Mi carrera",
            "Subtitle": "Selecciona una entrevista para ver la evaluación y tu encaje.",
            "MostRecentInterview": "Entrevista más reciente",
            "ToDo": "Pendiente",
            "NoOngoingInterviews_Title": "Aún no tienes nuevas invitaciones a entrevistas.",
            "NoOngoingInterviews_Subtitle": "Las nuevas entrevistas con Hubert aparecerán aquí cuando el equipo de selección las programe.",
            "NoRecentInterviews_Title": "No se han encontrado registros de entrevistas anteriores.",
            "NoRecentInterviews_Subtitle": "Cuando te inviten a una entrevista, aparecerá aquí abajo.",
            "ButtonText_StartInterview": "Ir a la entrevista",
            "ButtonText_NotScored": "Resultados pendientes",
            "ButtonText_Details": "Detalles"
        },
        "LearnWithHubert": {
            "Title": "Aprende con Hubert",
            "Subtitle": "Consejos para mejorar tus entrevistas y tu desempeño en el trabajo.",
            "PickedForMe": "Artículos recientes",
            "ButtonText_SeeAllArticles": "Ver todos los artículos"
        },
        "HubertTip": {
            "Title": "Consejo de Hubert",
            "Subtitle": "Haz entrevistas más rápido",
            "Description": "¿Vas a postularte a un puesto similar a otro para el que ya hiciste una entrevista con Hubert? Puedes reutilizar tus respuestas de aquella entrevista para ahorrar tiempo.",
            "ButtonText_ReadMoreTips": "Ver más consejos"
        },
        "NewCandidateModalPopup": {
            "Title": "¡Listo!",
            "DescriptionLine1": "Tu cuenta ya está preparada.",
            "DescriptionLine2": "Gestiona tus entrevistas y tu perfil. Consulta tus resultados, recibe feedback y aprende cómo mejorar en entrevistas.",
            "ButtonText_LetsGo": "Vamos"
        },
        "InterviewCompletedModal": {
            "Title": "¡Buen trabajo!",
            "Subtitle": "Has terminado tu entrevista.",
            "Description": "El equipo de selección revisará todas las candidaturas y se pondrá en contacto contigo por correo electrónico o teléfono cuando haya novedades.",
            "ButtonText_Continue": "Continuar"
        },
        "LatestJobPostings": {
            "Title": "Últimas ofertas",
            "Subtitle": "Explora otras ofertas de empresas colaboradoras de Hubert publicadas recientemente."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mis entrevistas",
        "MyInterviewsSection_Subtitle": "Selecciona una entrevista para ver la evaluación y tus oportunidades profesionales.",
        "MyInterviewsSection_ToDo": "Pendiente"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Ver todas las entrevistas",
        "InterviewNotFound_Title": "No puedes acceder a esta entrevista",
        "InterviewNotFound_Description": "Estás intentando acceder a los detalles de una entrevista que no está asociada a tu cuenta.",
        "ButtonText_GoToAllInterviews": "Ir a Mis entrevistas",
        "InterviewDetails": {
            "Title": "Detalles de la entrevista",
            "ForRole": "Para el puesto",
            "InterviewCompletedOn": "Entrevista completada el {{date}} a las {{time}}"
        },
        "MyResult": {
            "Title": "Mi resultado",
            "Subtitle": "Encaje evaluado",
            "ButtonText_LearnMore": "Cómo se evalúan tus respuestas",
            "GotPotential_Title": "Buen potencial, falta un requisito",
            "GotPotential_Description": "Tus respuestas muestran un buen potencial para este tipo de puesto. Sin embargo, según esta entrevista, es posible que no cumplas uno o varios requisitos obligatorios para esta oferta concreta. Esto puede afectar a los siguientes pasos, según las necesidades del equipo de reclutamiento y el conjunto de candidaturas. Si no te invitan a la siguiente fase, ten en cuenta que no es un reflejo de tu potencial como persona candidata. A menudo se trata simplemente de encontrar el encaje más preciso con las necesidades específicas del puesto. Mira otras oportunidades y consejos de mejora más abajo.",
            "GotPotential_DescriptionSecondary": "La evaluación de Hubert es orientativa. La decisión final la toma el equipo de reclutamiento y otros factores, como el número de candidatos, también pueden influir en el resultado.",
            "GreatMatch_Title": "Encaje fuerte",
            "GreatMatch_Description": "Tus respuestas encajan bien con lo que el equipo de reclutamiento suele buscar en este tipo de puesto y cumples los requisitos. ¡Buen trabajo! El equipo revisará todas las candidaturas y decidirá los siguientes pasos.",
            "GreatMatch_DescriptionSecondary": "La evaluación de Hubert es orientativa. La decisión final la toma el equipo de reclutamiento y otros factores, como el número de candidatos, también pueden influir en el resultado. Si no te invitan a la siguiente fase, ten en cuenta que no es un reflejo de tu potencial como persona candidata. A menudo se trata simplemente de encontrar el encaje más preciso con las necesidades específicas del puesto. Mira otras oportunidades y consejos de mejora más abajo.",
            "OkMatch_Title": "Cumples, añade más impacto",
            "OkMatch_Description": "Cumples los requisitos del puesto. Para destacar más, tus respuestas pueden ganar con más claridad y especificidad frente a lo que el equipo de selección suele ver en este tipo de roles. Revisa tus respuestas abajo para ver dónde un ejemplo concreto o un resultado puede subir tu puntuación.",
            "OkMatch_DescriptionSecondary": "La evaluación de Hubert es orientativa. La decisión final la toma el equipo de reclutamiento y otros factores, como el número de candidatos, también pueden influir en el resultado.",
            "NotClearMatch_Title": "Puede que aún no sea el encaje ideal",
            "NotClearMatch_Description": "Según esta entrevista, tus respuestas pueden estar menos alineadas con lo que busca el equipo de selección para este puesto, o puede que no cumplas uno o varios requisitos. Si quieres mejorar, empieza por las preguntas marcadas abajo. Pequeños cambios, más detalles y resultados claros pueden marcar una gran diferencia la próxima vez.",
            "NotClearMatch_DescriptionSecondary": "La evaluación de Hubert es orientativa. La decisión final la toma el equipo de reclutamiento y otros factores, como el número de candidatos, también pueden influir en el resultado."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Experiencia profesional, motivación y competencias",
            "QualifyingRequirements": "Requisitos para este puesto",
            "NotQualified_Title": "Hay margen de mejora",
            "NotQualified_Description": "Tus respuestas pueden haber sido menos específicas o menos enfocadas a resultados de lo que espera el equipo de reclutamiento. Fíjate en lo resaltado: añadir un ejemplo concreto, acciones que realizaste o un resultado claro puede reforzar tus respuestas.",
            "GreatResults_Title": "Respuestas sólidas",
            "GreatResults_Description": "Tus respuestas indican que encajas bien en este tipo de puesto y que te comunicas con claridad. Si alguna respuesta se puede mejorar, la verás resaltada abajo.",
            "MeetingRequirements_Title": "Cumpliendo requisitos",
            "MeetingRequirements_Description": "Tus respuestas indican que cumples los requisitos que el equipo de reclutamiento ha marcado para este puesto. Es una buena base.",
            "NotAllExpectationsMet_Title": "Falta uno o más requisitos",
            "NotAllExpectationsMet_Description": "Según tus respuestas, es posible que no cumplas uno o varios requisitos para este puesto en concreto, como certificados, licencias, nivel de estudios o años de experiencia.",
            "ButtonText_FindOutPossibleReasons": "Ver detalles"
        },
        "ScriptFromInterview": {
            "Title": "Lee tu entrevista completa",
            "ButtonText_SeeWholeTranscript": "Ver entrevista",
            "ButtonText_DeleteInterview": "Eliminar entrevista",
            "Loading_Title": "Cargando…",
            "Loading_Subtitle": "Espera mientras cargamos la transcripción de tu entrevista."
        },
        "HowToImproveAtInterviews": {
            "Title": "Cómo mejorar en entrevistas",
            "Subtitle_Questions": "Estas son algunas preguntas en las que tu respuesta podría mejorarse.",
            "Subtitle_NoQuestions": "No se han marcado respuestas concretas. Aquí tienes las mejores formas de añadir impacto para este puesto.",
            "GreatMatch_Questions_Description": "Aunque el encaje sea fuerte, algunas respuestas pueden reforzarse. Si detectamos alguna, la encontrarás abajo. Sigue las instrucciones antes de cada pregunta. Al describir una situación, incluye el contexto, lo que hiciste y el resultado. Responder “OK” no ayuda cuando te pedimos que desarrolles. A la vez, evita respuestas excesivamente largas. Busca descripciones claras y concretas, como en una entrevista cara a cara.",
            "GreatMatch_NoQuestions_Description": "Has respondido muy bien. ¡Buen trabajo!",
            "OkMatch_Questions_Description": "Abajo verás preguntas en las que tu respuesta podría mejorarse. Sigue las instrucciones antes de cada pregunta. Al describir una situación, incluye el contexto, lo que hiciste y el resultado. Responder “OK” no ayuda cuando te pedimos que desarrolles. A la vez, evita respuestas excesivamente largas. Busca descripciones claras y concretas, como en una entrevista cara a cara.",
            "OkMatch_NoQuestions_Description": "Tus respuestas han sido buenas, pero este puesto puede ser competitivo. Eso significa que incluso buenas respuestas pueden quedarse en la mitad del grupo.",
            "OkMatch_NoQuestions_DescriptionSecondary": "La próxima vez, busca claridad e impacto. Empieza por el resultado, añade un ejemplo real y mantén la respuesta breve (normalmente de 3 a 6 frases). Explica qué hiciste, cómo lo hiciste y qué cambió gracias a ello.",
            "GotPotential_Questions_Description": "Aunque parezcas un buen encaje para este tipo de trabajo, algunas respuestas pueden reforzarse. Si detectamos alguna, la encontrarás abajo. Sigue las instrucciones antes de cada pregunta. Al describir una situación, incluye el contexto, lo que hiciste y el resultado. Responder “OK” no ayuda cuando te pedimos que desarrolles. A la vez, evita respuestas excesivamente largas. Busca descripciones claras y concretas, como en una entrevista cara a cara.",
            "GotPotential_NoQuestions_Description": "No encontramos respuestas que necesiten una mejora importante en cuanto a competencias profesionales y motivación. Parece que has respondido bien en esos temas.",
            "NotClearMatch_Questions_Description": "Abajo verás preguntas en las que tu respuesta podría mejorarse. Sigue las instrucciones antes de cada pregunta. Al describir una situación, incluye el contexto, lo que hiciste y el resultado. Responder “OK” no ayuda cuando te pedimos que desarrolles. A la vez, evita respuestas excesivamente largas. Busca descripciones claras y concretas, como en una entrevista cara a cara.",
            "NotClearMatch_NoQuestions_Description": "No encontramos una sola respuesta “mala”. Se trata más del encaje global con lo que necesita este puesto. Si la competencia es fuerte, pequeñas diferencias pueden importar.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "En tu próxima entrevista, céntrate en dar ejemplos concretos. Elige un ejemplo por pregunta, explica tus acciones y comparte el resultado. Normalmente, breve y preciso supera a largo y general.",
            "Alert_WantMoreAdvice": "¿Quieres más consejos para hacerlo bien en una entrevista con Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Ver nuestro artículo de consejos generales"
        },
        "SimilarOffers": {
            "Title": "Ofertas similares"
        },
        "HowHubertScoresInterviews": {
            "Title": "¿Cómo evalúa Hubert las entrevistas?",
            "Description": "A continuación verás una breve explicación de cómo Hubert evalúa las respuestas de la entrevista. También hemos añadido una sección llamada Proceso de selección para explicar cómo suelen ser los siguientes pasos tras la entrevista con Hubert.",
            "Tabs_PossibleOutcomes": "Posibles resultados",
            "Tabs_RecruitmentProcess": "Proceso de selección",
            "AssessedMatch_Title": "Encaje evaluado",
            "AssessedMatch_Description": "Hubert evalúa cómo se perciben tus respuestas en conjunto, comparándolas con lo que el equipo de reclutamiento suele buscar en este tipo de puesto. Junto con los requisitos del rol, verás uno de los resultados de abajo.",
            "AssessedMatch_DescriptionSecondary": "La evaluación de Hubert es orientativa. La decisión final la toma el equipo de reclutamiento y otros factores, como el número de candidatos, también pueden influir en el resultado.",
            "GreatMatch_Title": "Encaje fuerte",
            "GreatMatch_Description": "Tus respuestas encajan bien con lo que el equipo de selección suele buscar en este tipo de puesto y cumples los requisitos. ¡Buen trabajo! El equipo revisará todas las candidaturas y decidirá los siguientes pasos.",
            "GotPotential_Title": "Buen potencial, falta un requisito",
            "GotPotential_Description": "Tus respuestas muestran un buen potencial para este tipo de puesto. Sin embargo, según esta entrevista, es posible que no cumplas uno o varios requisitos obligatorios para esta oferta concreta. Esto puede afectar a los siguientes pasos, según las necesidades del equipo de selección y el conjunto de candidaturas.",
            "OkMatch_Title": "Cumples los requisitos, añade más impacto",
            "OkMatch_Description": "Cumples los requisitos del puesto. Para destacar, tus respuestas pueden necesitar más claridad y especificidad frente a lo que el equipo de selección suele ver en este tipo de roles. Usa el feedback de tu entrevista para reforzar tus ejemplos y resultados de cara al futuro.",
            "NotClearMatch_Title": "Puede que aún no sea el encaje ideal",
            "NotClearMatch_Description": "Según esta entrevista, tus respuestas pueden estar menos alineadas con lo que busca el equipo de reclutamiento para este puesto y puede que no cumplas uno o varios requisitos. Revisa tus respuestas para ver dónde puedes añadir claridad, ejemplos y resultados.",
            "ProfessionalExperiences_Title": "Experiencia profesional, motivación y competencias",
            "ProfessionalExperiences_Description": "Estas preguntas tratan sobre tu experiencia previa, tu motivación por el puesto y las competencias relevantes para el rol. El equipo de selección decide qué preguntas se incluyen en la entrevista para cada oferta.",
            "GreatResults_Title": "Respuestas sólidas",
            "GreatResults_Description": "Tus respuestas indican que encajas bien en este tipo de puesto y que te comunicas con claridad. Si alguna respuesta se puede mejorar, la verás resaltada en tu entrevista.",
            "NotQualified_Title": "Hay margen de mejora",
            "NotQualified_Description": "Tus respuestas pueden haber sido menos específicas o menos enfocadas a resultados de lo que espera el equipo de selección. Fíjate en lo resaltado: añadir un ejemplo concreto, acciones que realizaste o un resultado claro puede reforzar tus respuestas.",
            "QualifyingRequirements_Title": "Requisitos básicos o obligatorios para este puesto",
            "QualifyingRequirements_Description": "Son preguntas que el equipo de reclutamiento ha definido como requisitos para el puesto. Por ejemplo, un certificado obligatorio, un permiso de conducir o un determinado nivel de experiencia relevante.",
            "MeetingRequirements_Title": "Cumpliendo requisitos",
            "MeetingRequirements_Description": "Tus respuestas indican que cumples los requisitos que el equipo de selección ha marcado para este puesto. Es una buena base.",
            "NotAllExpectationsMet_Title": "Falta uno o más requisitos",
            "NotAllExpectationsMet_Description": "Según tus respuestas, es posible que no cumplas uno o varios requisitos para este puesto en concreto, como certificados, licencias, nivel de estudios o años de experiencia.",
            "RecruitmentProcess_Title": "Proceso de selección",
            "RecruitmentProcess_Description": "Normalmente, Hubert se utiliza como primer paso en procesos con muchas candidaturas. Permite que cada persona complete una entrevista y se exprese con sus propias palabras. Como las preguntas son las mismas para todos los candidatos que se postulan al mismo puesto, el proceso es más consistente. Además, Hubert no utiliza información como edad, género, etnia, religión o apariencia, lo que ayuda a reducir el riesgo de sesgos inconscientes.",
            "EventOne_Title": "Haces la entrevista con Hubert",
            "EventOne_Description": "Puedes hacer la entrevista con Hubert cuando y donde te venga mejor. No hay límite de tiempo, y puedes pausar en cualquier momento y continuar donde lo dejaste.",
            "EventTwo_Title": "Se evalúa tu entrevista",
            "EventTwo_Description": "Hubert evalúa tus respuestas usando tecnología moderna. En cuanto se complete la evaluación, verás los resultados aquí en My Hubert y el equipo de selección los verá en su sistema de gestión de candidaturas.",
            "EventThree_Title": "El equipo de reclutamiento elige candidatos para los siguientes pasos",
            "EventThree_Description": "En su sistema de gestión de candidaturas, el equipo de reclutamiento puede ver cuándo hay un nuevo resultado de entrevista con Hubert. Después revisan tus respuestas y la evaluación de Hubert. Con la evaluación orientativa de Hubert y su propio criterio, deciden si te invitan a la siguiente fase (por ejemplo, una llamada, una prueba o una entrevista final). En algunos casos, pueden esperar antes de avanzar. Si otros candidatos encajan mejor, tu candidatura puede ser rechazada.",
            "ButtonText_Close": "Cerrar"
        }
    },
    "MyProfile": {
        "Title": "Mi perfil",
        "MyDetails": {
            "Title": "Mis datos",
            "Label_FirstName": "Nombre",
            "Label_LastName": "Apellidos",
            "Label_Email": "Correo electrónico",
            "Label_PhoneNumber": "Número de teléfono",
            "ButtonText_UpdateDetails": "Actualizar datos",
            "Error_FirstName_Required": "El nombre es obligatorio.",
            "Error_LastName_Required": "Los apellidos son obligatorios.",
            "Error_Email_Required": "El correo electrónico es obligatorio.",
            "Error_Email_Invalid": "Introduce un correo electrónico válido.",
            "Error_PhoneNumber_Invalid": "El número de teléfono no es válido.",
            "Success_Details_Updated": "Perfil actualizado."
        },
        "ChangePassword": {
            "Title": "Cambiar contraseña",
            "Set_Password_Title": "Crear contraseña",
            "Label_CurrentPassword": "Contraseña actual",
            "Label_NewPassword": "Nueva contraseña",
            "Label_RepeatNewPassword": "Repite la nueva contraseña",
            "Alert_SignInAgain": "Vuelve a iniciar sesión para configurar tu contraseña.",
            "ButtonText_UpdatePassword": "Actualizar contraseña",
            "ButtonText_SetPassword": "Establecer contraseña",
            "ButtonText_SignInAgain": "Iniciar sesión de nuevo",
            "Error_CurrentPassword_Required": "La contraseña actual es obligatoria.",
            "Error_CurrentPassword_DoesntMatch": "La contraseña no coincide con la contraseña actual.",
            "Error_NewPassword_Required": "La nueva contraseña es obligatoria.",
            "Error_NewPassword_6_Characters": "La nueva contraseña debe tener al menos 6 caracteres.",
            "Error_RepeatNewPassword_Required": "Debes repetir la nueva contraseña.",
            "Error_RepeatNewPassword_DoesntMatch": "La contraseña no coincide con la nueva contraseña.",
            "Success_Password_Changed": "Contraseña actualizada.",
            "Error_Invalid_CurrentPassword": "La contraseña actual no es válida."
        },
        "NotificationPreferences": {
            "Title": "Preferencias de notificaciones",
            "Label_ReceiveUpdatesToggle": "Quiero recibir novedades de Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Recibirás guías de carrera, consejos de entrevistas y más."
        },
        "AccountRemoval": {
            "Title": "Eliminar cuenta",
            "ButtonText_RemoveMyAccount": "Eliminar mi cuenta"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hola",
        "Subtitle": "Estás a punto de empezar tu entrevista de trabajo.",
        "TipBox_Title": "Aquí tienes algunos consejos para ayudarte a hacerlo bien.",
        "TipBox_Tip1": "Haz la entrevista en un lugar tranquilo, donde puedas concentrarte y escribir con comodidad.",
        "TipBox_Tip2": "Responde desde un ordenador con teclado (salvo que te resulte cómodo escribir textos largos en el móvil).",
        "TipBox_Tip3": "Sé lo más específico y detallado posible. Hubert y el equipo de selección quieren conocerte bien.",
        "TipBox_Tip4": "Tómate el tiempo que necesites. No hay límite de tiempo.",
        "TipBox_Tip5": "Puedes hacer una pausa cuando quieras y continuar donde lo dejaste.",
        "TipBox_Tip6": "Sé natural y afronta la entrevista con Hubert con el mismo compromiso que una entrevista con una persona.",
        "CheckAdviceArticle_Text1": "Si quieres más consejos para hacerlo bien en la entrevista, echa un vistazo a este",
        "CheckAdviceArticle_Text2": "artículo",
        "CheckAdviceArticle_Text3": "con recomendaciones muy útiles.",
        "ReadyToGetStarted": "¿Todo listo para empezar?",
        "ORSeparator_Text": "O",
        "ButtonText_StartInterviewNow": "Empezar la entrevista ahora",
        "ButtonText_SetReminder": "Ahora no, ponme un recordatorio",
        "PrivacyPolicyText": "Al pulsar “Empezar entrevista” aceptas la",
        "PrivacyPolicyLink": " Política de privacidad y los Términos y Condiciones"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "¡Buen trabajo!",
        "CompletedAlert_Subtitle": "Has terminado tu entrevista.",
        "CompletedAlert_Description": "El equipo de reclutamiento revisará todas las candidaturas y se pondrá en contacto contigo por correo electrónico o teléfono cuando haya novedades.",
        "InterviewNotCompleted": "Esta entrevista no está completada."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centro de ayuda",
            "Subtitle": "Encuentra respuestas a las preguntas más frecuentes sobre Hubert.",
            "Label_Search": "buscar preguntas frecuentes",
            "ButtonText_Search": "Buscar"
        },
        "FAQSection": {
            "Tabs_All": "Todas",
            "Tabs_AboutHubertInterview": "Sobre la entrevista con Hubert",
            "Tabs_TechnicalSupport": "Soporte técnico"
        },
        "StillHaveQuestion": {
            "Title": "¿Te queda alguna duda?",
            "Description": "Estaremos encantados de ayudarte.",
            "DropUsAEmail": "Escríbenos a hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "¿Puedo hacer la entrevista por teléfono en lugar de por chat?",
                    "a": "Por ahora, Hubert solo funciona por chat. Si tienes una condición médica que te impide realizar la entrevista, contacta la empresa que ofrece el puesto directamente. Hubert solo gestiona la entrevista por chat."
                },
                {
                    "q": "¿Puedo hacer la entrevista en otro idioma?",
                    "a": "En algunas entrevistas puedes seleccionar el idioma al inicio. Si esa opción no aparece, lo más probable es que entender el idioma de la entrevista sea un requisito del puesto. Si tienes más preguntas, ponte en contacto con la empresa que está llevando el proceso."
                },
                {
                    "q": "¿Me penalizan si doy respuestas cortas?",
                    "a": "No, siempre que respondas de forma adecuada a las preguntas. No hay una longitud mínima para una respuesta, pero aportar detalles suele ayudar."
                },
                {
                    "q": "¿Puedo reutilizar respuestas de otra entrevista con Hubert?",
                    "a": "Sí. Si has iniciado sesión en My Hubert y te postulas a un puesto similar, podrás reutilizar respuestas anteriores."
                },
                {
                    "q": "¿Una persona leerá mi entrevista?",
                    "a": "Sí. Nuestros clientes (las empresas que reclutan) revisan manualmente las entrevistas."
                },
                {
                    "q": "He hecho la entrevista, ¿qué pasa ahora?",
                    "a": "Para preguntas sobre el proceso (siguientes pasos, plazos o estado de tu candidatura), contacta la empresa que está reclutando. Encontrarás sus datos en los correos, la oferta de empleo o su web."
                },
                {
                    "q": "Tengo una pregunta sobre los siguientes pasos del proceso, ¿con quién debo hablar?",
                    "a": "Para preguntas sobre el proceso (siguientes pasos, plazos o estado de tu candidatura), contacta con la empresa que está reclutando. Encontrarás sus datos en los emails, la oferta de empleo o su web."
                },
                {
                    "q": "¿Cómo evitáis introducir sesgos en el proceso de selección?",
                    "a": "Reducir sesgos es clave para nosotros. Como sistema, Hubert puede ser más consistente en la evaluación que una persona. Nuestros modelos se entrenan con revisores expertos de perfiles diversos. Además, Hubert no utiliza datos como género, edad, etnia, religión o apariencia, que suelen ser fuentes de sesgo en entrevistas tradicionales."
                },
                {
                    "q": "¿Puedo hacer una entrevista con una persona en lugar de con Hubert?",
                    "a": "Hubert forma parte del proceso de selección definido por la empresa. Si necesitas una alternativa, contacta con la empresa que está reclutando para ver qué opciones tienen."
                },
                {
                    "q": "¿Hubert es una persona?",
                    "a": "No. Hubert es un asistente automatizado que realiza entrevistas por chat."
                },
                {
                    "q": "¿Puedo cambiar mis respuestas más tarde?",
                    "a": "No. Una vez enviada una respuesta, no se puede editar. Te recomendamos revisar lo que escribes antes de enviarlo."
                },
                {
                    "q": "¿Cómo puedo hacerlo bien en la entrevista con Hubert?",
                    "a": "Responde con ejemplos concretos y sé claro. Cuando describas una situación, incluye el contexto, lo que hiciste y el resultado. Evita respuestas muy cortas tipo “OK”, y tampoco haz textos excesivamente largos: busca claridad y concreción."
                },
                {
                    "q": "Necesito trabajo, ¿con quién debo hablar?",
                    "a": "Los siguientes pasos los decide la empresa en función de la evaluación de Hubert y su propio criterio. Puede ser una llamada, una prueba o una entrevista final. Si no has recibido noticias, puedo ayudarte contactar con la empresa para preguntar por el estado de tu candidatura."
                },
                {
                    "q": "He hecho la entrevista pero no he recibido noticias. ¿Qué hago?",
                    "a": "La competencia puede ser alta, incluso con perfiles muy cualificados. Si tu candidatura fue rechazada, puedes contactar la empresa para pedir feedback. También puedes revisar My Hubert para ver comentarios basados en tus respuestas y descubrir otras oportunidades."
                },
                {
                    "q": "Tengo mucha experiencia, pero no conseguí el puesto. ¿Por qué?",
                    "a": "La competencia puede ser alta, incluso con perfiles muy cualificados. Si tu candidatura fue rechazada, puedes contactar con la empresa para pedir feedback. También puedes revisar My Hubert para ver comentarios basados en tus respuestas y descubrir otras oportunidades."
                },
                {
                    "q": "¿Cuánto dura la entrevista?",
                    "a": "Suele llevar solo unos minutos, dependiendo de las preguntas y de lo detalladas que sean tus respuestas."
                },
                {
                    "q": "¿Dónde puedo leer cómo se gestionan mis datos?",
                    "a": "Puedes consultar la Política de privacidad y los Términos y Condiciones de Hubert. También es posible que la empresa que recluta tenga su propia política de privacidad aplicable al proceso."
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "¿Por qué no puedo ver mis entrevistas anteriores con Hubert?",
                    "a": "Asegúrate de haber usado el mismo correo electrónico al postularte que el que estás usando para iniciar sesión en My Hubert. Esto también aplica si entras con Google: el correo de Google debe coincidir con el de la candidatura. Prueba a crear una cuenta con el correo que usaste para postularte."
                },
                {
                    "q": "¿Por qué no he recibido el correo electrónico de mi entrevista?",
                    "a": "Revisa la carpeta de spam. También puedes añadir hubert@hubert.ai a tus contactos. Como alternativa, crea una cuenta en My Hubert (con el correo de la candidatura) para encontrar allí el enlace de la entrevista."
                },
                {
                    "q": "No encuentro el enlace de mi entrevista en el correo electrónico.",
                    "a": "Revisa la carpeta de spam. Como alternativa, crea una cuenta en My Hubert (con el correo de la candidatura) y ve a “Mis entrevistas” para encontrar el enlace."
                },
                {
                    "q": "¿La entrevista funciona en el móvil?",
                    "a": "Sí. Aun así, si te resulta más cómodo escribir en un ordenador, te recomendamos usarlo."
                },
                {
                    "q": "La entrevista no funciona, ¿qué puedo hacer?",
                    "a": "Lo lamentamos. Escríbenos a hubert@hubert.ai y te ayudaremos."
                },
                {
                    "q": "Quiero borrar mi cuenta de My Hubert, ¿qué debo hacer?",
                    "a": "Escríbenos a hubert@hubert.ai y te ayudaremos."
                },
                {
                    "q": "La entrevista se ha interrumpido, ¿cómo puedo volver?",
                    "a": "Haz clic en el enlace del correo electrónico de invitación para volver donde lo dejaste, o inicia sesión en My Hubert y selecciona la entrevista en “Mis entrevistas”."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Aprende con Hubert",
            "Subtitle": "Descubre cómo aumentar tus posibilidades en el proceso de selección y rendir mejor en el trabajo.",
            "Label_Search": "buscar guías de entrevistas y carrera",
            "ButtonText_Search": "Buscar"
        },
        "TabSelector": {
            "MyFeed": "Mi feed",
            "InterviewGuides": "Guías de entrevistas",
            "CareerGuides": "Guías de carrera"
        },
        "NewestOnTheFeed": "Lo último en el feed",
        "PickedForMe": "Artículos recientes",
        "InterviewGuides": "Guías de entrevistas",
        "CareerGuides": "Guías de carrera"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Volver a todos los artículos"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Restablecer tu contraseña",
        "ResetLinkAlert_Subtitle": "Haz clic en el enlace de restablecimiento enviado a tu correo para crear una nueva contraseña e iniciar sesión.",
        "PasswordNotSetAlert_Message": "No hay contraseña configurada; inicia sesión con ",
        "ResetYourPassword": {
            "MainTitle": "Ver los resultados de tu entrevista con Hubert",
            "Subtitle": "Inicia sesión para ver resultados, recibir feedback, leer consejos y mucho más.",
            "FormSectionTitle": "Restablecer tu contraseña",
            "Label_NewPassword": "Nueva contraseña",
            "Label_ConfirmNewPassword": "Confirmar nueva contraseña",
            "Error_NewPassword_Required": "Introduce una nueva contraseña.",
            "Error_Password_6_Characters": "La nueva contraseña debe tener al menos 6 caracteres.",
            "Error_ConfirmNewPassword_Required": "Debes confirmar tu nueva contraseña.",
            "Error_ConfirmNewPassword_NotMatch": "La contraseña no coincide con la nueva contraseña.",
            "Error_MalformedResetUrl": "Código de seguridad no válido. Inténtalo de nuevo.",
            "Error_ResetPasswordFailed": "Ha surgido un problema al restablecer la contraseña. Inténtalo de nuevo.",
            "Error_WeakPassword": "La contraseña debe tener al menos 6 caracteres.",
            "Error_InvalidCode_Title": "Tu solicitud para restablecer la contraseña ha caducado o no es válida.",
            "Error_InvalidCode_Subtitle": "Vuelve a intentar restablecer tu contraseña.",
            "ButtonText_SetNewPassword": "Establecer nueva contraseña e iniciar sesión",
            "ButtonText_RememberYourPassword": "¿Recuerdas tu contraseña?",
            "ButtonText_SignInInstead": "Inicia sesión en su lugar"
        }
    },
    "PageNotFound": {
        "Title": "Página no encontrada",
        "Description": "No encontramos la página que buscas.",
        "ButtonText_GoToDashboard": "Ir al panel",
        "ButtonText_GoToLogin": "Ir a inicio de sesión"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Aún no se pueden reutilizar respuestas en esta entrevista. Esperamos tener esta función disponible pronto, pero ya puedes hacer la entrevista ahora.",
        "DescriptionLine2": "Continúa a la entrevista haciendo clic en el botón de abajo.",
        "ButtonText_TakeMeToTheInterview": "Ir a la entrevista"
    },
    "UnsubscribeFromEmails": {
        "Title": "¿Seguro?",
        "Subtitle": "Dejarás de recibir correos nuestros sobre este puesto:",
        "SelectTheReason": "Selecciona una razón de las opciones de abajo.",
        "ReasonText1": "He encontrado otro trabajo.",
        "ReasonText2": "Ya no me interesa este puesto.",
        "ReasonText3": "Otro",
        "ButtonText_Unsubscribe": "Darme de baja de este puesto",
        "Placeholder_YourReason": "Tu razón",
        "Success_Title": "Te has dado de baja correctamente de los correos sobre este puesto.",
        "Loading": "Cargando…",
        "Error_YourReason_Required": "Introduce una razón.",
        "Error_ServerIssue": "No se ha podido completar la baja por un error del servidor."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Volver a intentarlo"
    },
    "Outreach": {
        "CandidateNotFound": "Candidato no encontrado",
        "CandidateNotFoundDesc": "No hemos podido encontrar los detalles de la entrevista que buscas.",
        "InterviewEnded": "Entrevista finalizada",
        "InterviewEndedDesc1": "Esta sesión de entrevista ha finalizado o ya no está disponible.",
        "InterviewEndedDesc2": "Gracias por tu tiempo. Si tienes alguna duda, contacta con el equipo de selección.",
        "ReadyTitle": "¿Todo listo para tu entrevista, {{firstName}}?",
        "InvitationDesc": "Hubert, en nombre de {{companyName}}, te invita a una entrevista por chat. Se completa en 1–2 minutos aproximadamente.",
        "Button_StartChat": "Empezar entrevista por chat",
        "CancelNotice": "Si empiezas aquí, se cancelará la llamada programada para este puesto.",
        "PreferNotToContinue": "¿Prefieres no continuar?",
        "DeclineLabel": "No me interesa este puesto. Por favor, no me llaméis ni me escribáis de nuevo sobre esta vacante.",
        "Button_ConfirmAndDecline": "Confirmar y rechazar",
        "Processing": "Procesando…",
        "Toast_DeclineSuccess": "Entrevista rechazada.",
        "Toast_CancelVoiceInfo": "Llamada cancelada. Función disponible próximamente.",
        "Toast_CancelError": "No se ha podido cancelar la entrevista. Inténtalo de nuevo.",
        "Footer_WithdrawConsent": "Puedes retirar tu consentimiento en cualquier momento. Más información en la política de privacidad de ",
        "Footer_PrivacyPolicySuffix": "",
        "Footer_And": " y en la ",
        "Footer_HubertPrivacyLink": "Política de privacidad y los Términos y Condiciones de Hubert",
        "Chat_InterviewWith": "Entrevista con {{companyName}}",
        "Chat_StatusConnected": "Conectado",
        "Chat_StatusError": "Error",
        "Chat_StatusDisconnected": "Desconectado",
        "Chat_StatusConnecting": "Conectando…",
        "Chat_ReadyToStart": "¿Todo listo para empezar la entrevista?",
        "Chat_ButtonStart": "Empezar entrevista",
        "Chat_SayHello": "Di hola para empezar la conversación.",
        "Chat_EmptyState": "Envía un mensaje para empezar la entrevista.",
        "Chat_SelectLanguage": "Elige tu idioma",
        "Chat_Placeholder": "Escribe tu mensaje…",
        "Chat_ButtonSend": "Enviar",
        "Chat_ButtonBack": "Atrás",
        "LoadingCandidateDetails": "Cargando datos del candidato…",
        "FetchingCandidateDetails": "Obteniendo datos del candidato…",
        "Chat_StatusReady": "Esperando para conectar…",
        "Chat_ForbiddenError": "Esta entrevista por chat ya no está disponible.",
        "Chat_GeneralError": "No se ha podido iniciar el chat. Inténtalo más tarde.",
        "Chat_SelectUiLanguage": "Idioma de la interfaz",
        "Chat_InterviewTitle": "Entrevista de trabajo"
    }
}
